var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98023 16.3004H4.77334C4.62107 16.3004 4.47504 16.2399 4.36737 16.1322C4.25971 16.0246 4.19922 15.8785 4.19922 15.7263V12.5194C4.19922 12.444 4.21407 12.3693 4.24292 12.2997C4.27177 12.23 4.31406 12.1667 4.36737 12.1134L12.9791 3.50165C13.0868 3.39398 13.2328 3.3335 13.3851 3.3335C13.5374 3.3335 13.6834 3.39398 13.7911 3.50165L16.998 6.70855C17.1056 6.81621 17.1661 6.96224 17.1661 7.11451C17.1661 7.26677 17.1056 7.4128 16.998 7.52047L8.38619 16.1322C8.33288 16.1855 8.26959 16.2278 8.19994 16.2567C8.13028 16.2855 8.05563 16.3004 7.98023 16.3004Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0879 5.39209L15.1067 9.41091",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18195 16.2635L4.23633 12.3179",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditStyle);
export default __webpack_public_path__ + "static/media/edit_style.7205df2a7410207786fa8260d2b7b419.svg";
export { ForwardRef as ReactComponent };